import PropTypes from 'prop-types';
import React from 'react';
import SocialLinkRowItemLazy from './SocialLinkRowItemLazy';

import style from './SocialLinkRow-style.scss';

const SocialLinkRow = props => {
    const { items, isClient } = props;

    return (
        <nav>
            <ul className={style.row}>
                {isClient &&
                    items.map(item => {
                        return (
                            <React.Suspense fallback={''} key={item.name}>
                                <SocialLinkRowItemLazy {...item} />
                            </React.Suspense>
                        );
                    })}
            </ul>
        </nav>
    );
};

SocialLinkRow.propTypes = {
    items: PropTypes.array,
    isClient: PropTypes.bool,
};

export default SocialLinkRow;
